import React, { useEffect } from 'react'
import { Card, CardBody, Row, Col, Table, Button } from "reactstrap";
import { urlPlanesApAbierto, urlPlanesApAbiertoAsistencias } from '../../constants/urls';
import { Checkbox } from "react-inputs-validation";
import NumberFormat from 'react-number-format';



const TablaPlanes = ({
  verBoton,
  carritoActual,
  onSubmit,
  idCarrito,
  idProducto,
  categorias,
  mostrarTabla,
  actividad,
  categoria,
  categoriaObjeto,
  numeroPersonas,
  muerteAccidental,
  valorFracturaHuesos,
  agregarAsistencias,
  setMostrarTabla,
  history,
  totales,
  setTotales,
  valuesCoberturas,
  setValuesCoberturas,
  valuesAsistencia,
  setValuesAsistencia,
  tieneErrores,
  setTieneErrores,
  coberturas2,
  setCoberturas2,
  setTitulo,
  setCodProducto,
  codProducto,
  asistencias,
  setAsistencias,
  asistenciasSeleccionadas,
  setAsistenciasSeleccionadas,
  asistenciasExpandidas,
  setAsistenciasExpandidas,
  validate,
  setValidate,
  setEditaAsistencias,
  errores

}) => {









  useEffect(() => {
    obtenerInformacionCoberturas(categoria, numeroPersonas, muerteAccidental, valorFracturaHuesos)
    obtenerInformacionAsistencias()

    if (actividad) {
      obtenerInformacionActividad()
    }
  }, [])

  /**
   * 
   * @returns Obtiene asistencias de acuerdo al porcentaje del valor de la poliza
   */
  const obtenerAsistenciasPorPrecio = () => {
    var precioMaximo = parseFloat(totales.valorTotalPermitidoEnAsistencias)

    var aux = 0
    var auxAsistencias = []

    asistencias.forEach(asistencia => {
      aux += parseFloat(asistencia.costoFinalAnual)
      if (aux <= precioMaximo) (
        auxAsistencias.push(asistencia)
      )
    });

    return auxAsistencias
  }


  /**
   * Obtiene información de coberturas para llenar la tabla correspondiente
   * @param {*} categoria Categoría seleccionada por el usuario
   * @param {*} numeroPersonas  Número de personas ingresadas por el usuario
   * @param {*} muerteAccidental Valor de muerte accidental
   */
  const obtenerInformacionCoberturas = async (categoria, numeroPersonas, muerteAccidental, valorFracturaHuesos, numeroDias) => {

    var url = `${urlPlanesApAbierto}`;
    var body = {
      "codCobertura": categoria,
      "empresa": "AIGMETROPOLITANA",
      "numeroPersonas": numeroPersonas,
      "valorMuerteAccidental": muerteAccidental,
      "valorFracturaHuesos": valorFracturaHuesos,
      "numeroDias": numeroDias,
      "sucursal": carritoActual.sucursal.value,
    }


    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()

      if (json.transaccion) {
        console.log('json.coberturas', json.coberturas)
        setCoberturas2(json.coberturas)
        setTitulo(json.tituloPlanCobertura)
        setCodProducto(json.codProducto)

        const valores = {}
        const valoresValidaciones = {}

        json.coberturas.forEach(element => {

          var valor = categorias.find(categoria => categoria.codigoCobertura == element.codigoCobertura)

          const valorAux = valor ? valor.valorAsegurado : 0;
          var valorAsegurado = !idProducto ? 0 : valorAux
          if ((element.codigoCobertura == '7' && valorAux > 0) || (element.codigoCobertura == '8' && valorAux > 0)) {
            valores['6'] = element.valorAsegurado ? element.valorAsegurado : Math.trunc(valorAsegurado)
            valores[element.codigoCobertura] = 0
          } else {
            valores[element.codigoCobertura] = element.valorAsegurado ? element.valorAsegurado : Math.trunc(valorAsegurado)
          }

          valoresValidaciones[element.codigoCobertura] = false
        });

        console.log('verErrores', valoresValidaciones, valores)
        setTieneErrores(valoresValidaciones)
        setValuesCoberturas(valores)



      }

    } catch (error) {
    }
  }


  /**
   * Obtiene información de una actividad meditante los parametros de la URL
   */
  const obtenerInformacionActividad = async () => {
    var url = `${urlPlanesApAbierto}`;
    var body = {
      "empresa": "AIGMETROPOLITANA",
      "plataforma": "WEB",
      "ambiente": "Desarrollo",
      "idCarrito": idCarrito,
      "sucursal": carritoActual.sucursal.value,
      "codigoProductoActual": actividad
    }
    try {
      const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
      const json = await response.json()

      if (json.transaccion) {
        console.log('verTrac', json)


      }

    } catch (error) {
    }
  }


  /**
   * Obtiene la lista de asistencias
   */
  const obtenerInformacionAsistencias = async () => {

    var url = `${urlPlanesApAbiertoAsistencias}`;

    try {
      const response = await fetch(url,)
      const json = await response.json()

      if (json.transaccion) {

        const valores = {}

        json.asistencias.forEach(element => {
          valores[element.codigo] = false
        });

        console.log('verAsist', valores)

        setValuesAsistencia(valores)

        setAsistencias(json.asistencias)
      }

    } catch (error) {
    }
  }







  return (
    <div>
      {mostrarTabla && coberturas2.length > 0 &&
        <div>


          <Card >
            <CardBody>



              <Table borderless responsive size={'md'}>

                <thead>
                  <tr>
                    <th  >
                      <div className="div-align-center" style={{ backgroundColor: "#001871", width: 380 }}>
                        <p style={{ color: `white`, textAlign: "center", textTransform: "uppercase" }} >{'MONTO ASEGURADO POR PERSONA '}</p>
                      </div>
                    </th>
                    <th  >
                      <div className="div-align-center" style={{ backgroundColor: "#001871", width: 200 }}>
                        <p style={{ color: `white`, textAlign: "center", textTransform: "uppercase" }} >{'Valor asegurado '}</p>
                      </div>
                    </th>
                    <th  >
                      <div className="div-align-center" style={{ backgroundColor: "#001871", width: 150 }}>
                        <p style={{ color: `white`, textAlign: "center", textTransform: "uppercase" }} >{'Valor máximo '}</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {coberturas2.map((cobertura) => {
                    return (
                      !cobertura.hidden ?
                        <tr>
                          <td>
                            <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: 380, height: 71.98 }}>
                              <p style={{ textAlign: "center" }} >{cobertura.cobertura}</p>


                            </div>
                          </td>
                          <td>
                            <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: 200, height: 71.98 }}>




                              <NumberFormat
                                className="form-control"
                                disabled={cobertura.disabled}
                                value={valuesCoberturas[cobertura.codigoCobertura]}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix={''}
                                onValueChange={(valor, e) => {

                                  var esMayor = valor.floatValue > parseFloat(cobertura.valorMaximo)
                                  var objeto = { ...valuesCoberturas }
                                  if (!esMayor) {


                                    objeto[cobertura.codigoCobertura] = valor.value;


                                  }


                                  setValuesCoberturas(objeto)
                                  setAsistenciasSeleccionadas([])
                                  setTotales({})


                                }}

                              />

                              {cobertura.error &&
                                <div style={{bottom:10, position: 'relative', textAlign:'center'}} class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{cobertura.error}</div>
                              }





                            </div>
                          </td>
                          <td>
                            <div className="div-align-center" style={{ backgroundColor: "#F0F0EB", width: 150, height: 71.98 }}>
                              <p style={{ textAlign: "center" }} >


                                <NumberFormat
                                  value={cobertura.valorMaximo}
                                  className="foo"
                                  displayType={'text'}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  decimalScale={0}
                                  fixedDecimalScale={0}
                                  prefix={cobertura.simbolo}
                                  renderText={(value, props) => <div {...props}>{value}</div>}
                                />

                              </p>
                            </div>
                          </td>
                        </tr> : null
                    )
                  })}





                </tbody>
              </Table>



              <Table borderless responsive size={'md'}>

                <tbody>


                  <tr>


                    <td>



                    </td>
                    <td>



                    </td>
                  </tr>



                </tbody>
              </Table>

            </CardBody>
          </Card>



          {(totales.primaNetaPorPersona && obtenerAsistenciasPorPrecio().length > 0) &&

            <div>

              <Card>
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}>
                    {" "}
                    Asistencias Adicionales
                  </h4>
                  <div>
                    (Si deseas puedes añadir las siguientes asistencias para tu
                    póliza dando click en el botón "Agregar".)
                  </div>
                  <p />
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <ul class="a-container-gray">
                        {obtenerAsistenciasPorPrecio().map((asistencia) => {

                          console.log('asistencia.textoDefinicion', asistencia.textoDefinicion)

                          const descripcionCompleta = asistencia.textoDefinicion.replace('able cellspacing="0" style="width:663pt"', 'able cellspacing="0" style="auto"')
                          const descripcionCorta = descripcionCompleta.substring(0, 160) + "..."
                          return (
                            <li class="a-items">
                              <input
                                type="radio"
                                name="amparogm"
                                id="amparogm"
                              />
                              <label for="amparogm">
                                <Row>
                                  <Col md={10}>
                                    {
                                      asistencia.nombreAsistencia
                                    }
                                  </Col>
                                  {/* <Col md={2} style={{textAlign:'left'}}>
                                    <strong>
                                      {
                                        '$'+asistencia.costoFinalAnual
                                      }
                                    </strong>
                                  </Col> */}

                                </Row>





                              </label>

                              <div class="a-content-gray">
                                <Row>
                                  <Col lg={9} md={9} sm={8} xs={12}>
                                    <p style={{
                                      textAlign: "justify",
                                    }}>



                                      <div
                                        dangerouslySetInnerHTML={{ __html: asistenciasExpandidas.find(asistenciaAux => asistenciaAux == asistencia) ? descripcionCompleta : descripcionCorta }}
                                        style={{ width: '100%' }}
                                      />

                                      <Button
                                        onClick={() => {

                                          var asistenciasSelect = [...asistenciasExpandidas];

                                          var check = asistenciasExpandidas.find(asistenciaAux => asistenciaAux == asistencia)
                                          if (!check) {
                                            asistenciasSelect.push(asistencia)
                                          } else {
                                            var index = asistenciasSelect.indexOf(asistencia);
                                            if (index !== -1) {
                                              asistenciasSelect.splice(index, 1);
                                            }
                                          }

                                          setAsistenciasExpandidas(asistenciasSelect)

                                        }}
                                        color="link"
                                      >

                                        {asistenciasExpandidas.find(asistenciaAux => asistenciaAux == asistencia) ? 'Ver menos' : 'Ver más'}

                                      </Button>

                                    </p>





                                  </Col>
                                  <Col lg={3} md={3} sm={4} xs={12}>
                                    <Checkbox
                                      id={asistencia.id} // Optional.[String].Default: "".  Input ID.
                                      name={asistencia.id} // Optional.[String].Default: "". Input name
                                      //value={value} // Required.[String].Default: "".
                                      checked={valuesAsistencia[asistencia.codigo]} // Required.[Bool].Default: false.
                                      onChange={(check, e) => {
                                        //setTotales({})
                                        setEditaAsistencias(true)
                                        var objeto = { ...valuesAsistencia }
                                        objeto[asistencia.codigo] = check;

                                        setValuesAsistencia(objeto)

                                        var asistenciasSelect = asistenciasSeleccionadas;
                                        if (check) {
                                          asistenciasSelect.push(asistencia)
                                        } else {
                                          var index = asistenciasSelect.indexOf(asistencia);
                                          if (index !== -1) {
                                            asistenciasSelect.splice(index, 1);
                                          }
                                        }

                                        setAsistenciasSeleccionadas(asistenciasSelect)

                                        console.log('asistenciasSelect', asistenciasSelect)
                                      }}
                                      labelHtml={
                                        <div style={{ background: "none" }}>
                                          {valuesAsistencia[asistencia.codigo] ? 'Quitar' : 'Agregar'}
                                        </div>
                                      }


                                    />
                                  </Col>
                                </Row>
                              </div>
                            </li>

                          )
                        })}


                      </ul>
                    </Col>
                  </Row>
                </CardBody>
              </Card>


            </div>



          }





        </div>

      }



    </div>






  );
};

export default TablaPlanes;
